import api from "api";

const location = {
    getLocation: (lat, long) => {
        return api().get(`/addresses/latlng/${lat}/${long}`)
    },

}

export default location;